import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VuejsDialog from 'vuejs-dialog';
import Datetime from 'vue-datetime';
import Login from './components/Login.vue'
import Operations from './components/Operations.vue'
import Dashboard from './components/Dashboard.vue'
import EmailEditor from './components/EmailEditor.vue'
import TourPlanner from './components/TourPlanner.vue'
import TourList from './components/TourList.vue'
import Documentation from './components/Documentation.vue'
import ImageUploader from 'vue-image-upload-resize'
import Moment from 'vue-moment'


import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'vue-datetime/dist/vue-datetime.css';

Vue.use(VuejsDialog);
Vue.use(ImageUploader);
Vue.use(VueRouter);
Vue.use(Moment);


Vue.config.productionTip = false

export const serverBus = new Vue();

const routes = [{
  path: '/login',
  component: Login
}, {
  path: '/documentation',
  component: Documentation
}, {
  path: '/operations',
  component: Operations
}, {
  path: '/dashboard',
  component: Dashboard
}, {
  path: '/emaileditor',
  component: EmailEditor
}, {
  path: '/tourplanner',
  component: TourPlanner
}, {
  path: '/touren',
  component: TourList
}]

const router = new VueRouter({
  routes
})

Vue.filter('uppercase', function(value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
